import { render } from "./LottoEventBet.vue?vue&type=template&id=0cb04ef9&scoped=true"
import script from "./LottoEventBet.vue?vue&type=script&lang=js"
export * from "./LottoEventBet.vue?vue&type=script&lang=js"

import "./LottoEventBet.vue?vue&type=style&index=0&id=0cb04ef9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb04ef9"]])

export default __exports__